import { GetterTree } from "vuex";
import { StoreState } from "@/store/type";
import { IGroupsState } from "./state";

const getters: GetterTree<IGroupsState, StoreState> = {
  groupsList: (state) => state.groups,
  isFetchingGroups: (state) => state.isLoading,
  groupBookingDetail: (state) => state.bookingDetail,
  isFetchingGroupBookingDetail: (state) => state.isFetchingBookingDetail,
  isBookingGroup: (state) => state.isBooking,
  isUpdatingGroupPassengers: (state) => state.isUpdatingPassengers,
  groupPayingInvoiceId: (state) => state.payingInvoiceId,
};

export default getters;
